import api from "../../services/api";
import { Creators } from "../ducks/notify_etl";
import { call, put } from "redux-saga/effects";
import { actions as toastrActions } from "react-redux-toastr";
import { captureSentryException } from '../../utils';

export function* getNotifyEtl({ data }) {
  try {
    let response;

    yield put(Creators.notifyEtlRequest());
    response = yield call(api.post, "notify-etl", { data });
    yield put(Creators.notifyEtlSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, data);
    yield put(Creators.notifyEtlError({ err }));
    yield put(
      toastrActions.add({
        type: "error",
        title: "Erro",
        message: "Falha ao buscar configurações.",
      })
    );
  }
}

export function* putNotifyEtl({ data }) {
  try {
    let response;

    yield put(Creators.notifyEtlRequest());
    response = yield call(api.put, "notify-etl", {
      ...data,
    });

    yield put(Creators.notifyEtlSuccess(response.data));
    yield put(
      toastrActions.add({
        type: "success",
        title: "Sucesso",
        message: "Alterações salvas com sucesso.",
      })
    );
  } catch (err) {
    yield captureSentryException(err, data);
    yield put(Creators.notifyEtlError({ err }));
    yield put(
      toastrActions.add({
        type: "error",
        title: "Erro",
        message: "Falha ao salvar configurações.",
      })
    );
  }
}
